







import {Component, Prop, Vue} from 'vue-property-decorator'
import IconCustom from '@/components/lib/IconCustom.vue'
import {AvailableIconsArray} from './models'

@Component({
  components: {
    IconCustom
  }
})
export default class GlyphCustom extends Vue {
  @Prop() name!: string

  private maxAbbreviationLength = 2;

  get haveIcon(): boolean {
    return AvailableIconsArray.map((item: string) => item).indexOf(this.name) !== -1
  }

  get abbreviation(): string {
    let parts = this.name.split(' ');
    let res = '';
    for (let i = 0; i < parts.length; i++) {
      let letter = parts[i][0]
      res += letter.match(/^[A-Za-zА-Яа-я]$/) ? letter : '';
      if (res.length >= this.maxAbbreviationLength) break;
    }
    return res;
  }

}
